import { useNetworxServices } from "../../../../../hooks/queries/useNetworxServices";
import { FloatingMenu } from "@/components/ui/FloatingMenu";
import ChevronDownIcon from "../assets/ChevronDownIcon";
import MobileNavLinks from "../MobileDrawer/LoggedInMobileDrawerContent/MobileNavLinks";

export default function DesktopNavigation() {
  const { data } = useNetworxServices({
    sortBy: "alphabetical",
  });
  const services = data?.services ?? [];

  // Group services into 3 columns
  const columnSize = Math.ceil(services.length / 3);
  const columns = [
    services.slice(0, columnSize),
    services.slice(columnSize, columnSize * 2),
    services.slice(columnSize * 2),
  ];

  return (
    <div className="flex items-center gap-x-10 whitespace-nowrap">
      {/* Find a Pro with FloatingMenu */}
      <FloatingMenu>
        <FloatingMenu.Trigger>
          <div
            className="flex items-center gap-1.5 text-base xl:text-lg text-primary cursor-pointer font-semibold"
          >
            Find a Pro <ChevronDownIcon className="size-4 mt-1 text-primary" />
          </div>
        </FloatingMenu.Trigger>
        <FloatingMenu.Content width="w-max" classNames={{
          card: "shadow-[0_5px_20px_rgb(0_0_0_/_25%)]",
        }}>
          <div className="flex gap-10">
            {columns.map((column, colIndex) => (
              <ul key={colIndex} className="flex min-w-max flex-col gap-2">
                {column.map((service) => (
                  <li key={service.id}>
                    <a
                      href={service.pathname}
                      className="block rounded-md px-3 py-0.5 text-sm !text-primary hover:!no-underline hover:bg-default-100"
                    >
                      {service.display_name}
                    </a>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </FloatingMenu.Content>
      </FloatingMenu>

      {/* Other Navigation Links */}
      <MobileNavLinks classNames={{ base: "p-0 text-base xl:text-lg font-semibold" }}/>
    </div>
  );
}
